// recoil/entityDropdown.ts
import { atomFamily, selectorFamily } from 'recoil';
import APIService from '../../APIService';
import { entityDropdownAtom } from './entity.ts';
import { Apis } from '../../app.constants.js';

export const entityDropdownSelector = selectorFamily({
  key: 'entityDropdownSelector',
  get:
    (params: {
      entityFormId: string;
      returnFields?: string[];
      queryParams?: {
        param?: string;
        paramValue?: string;
        matched_with?: string;
        entity_form_field?: string;
        entity_record_id?: string;
      }[];
    }) =>
    async ({ get }) => {
      const { entityFormId, returnFields = [], queryParams = [] } = params;
      const cached = get(entityDropdownAtom(entityFormId));
      if (cached.length) return cached;
      let flag = true;
      for (const param of queryParams) {
        if (
          param.param === 'global_phone_number' &&
          (!param?.paramValue || param?.paramValue?.length < 10)
        ) {
          flag = false;
          break;
        }
        if (param?.entity_form_field) {
          if (!param?.entity_record_id) {
            flag = false;
            break;
          }
        } else if (param.param && !param.paramValue) {
          flag = false;
          break;
        }
      }
      if (!flag) return [];
      try {
        let url = `${Apis?.entityDropdownUniqueRecord}`;
        const res: any = await APIService.post(url, { ...params });
        const items = res?.data?.data?.items || [];
        return items;
      } catch (err) {
        console.error('Failed to fetch entity data', err);
        return [];
      }
    },
});
